import cn from 'classnames';
import { OnHoverTooltip } from "./OnHoverTooltip";
import { PeriodPopover } from "../amrPipeline/aggregated/PeriodPopover";
import { constants } from "../../constants";
import { formatUtils } from "../../utils";
import IconSVG from "../../styles/svg-icons";
import { calculatePeriodEndYears } from "../../types/state/FilterPeriodState";


type TMode = 'reinvestment' | 'nonCall';

interface Props {
    mode: TMode
    reinvestmentPeriodEnd?: Date
    nonCallPeriodEnd?: Date
}

export function PeriodEnd({ mode, reinvestmentPeriodEnd, nonCallPeriodEnd }: Props) {
    const periodEnd = mode === 'reinvestment' ? reinvestmentPeriodEnd : nonCallPeriodEnd;

    const periodEndYears = calculatePeriodEndYears(periodEnd);

    return (
        <OnHoverTooltip
            overlay={
                <PeriodPopover
                    reinvestmentPeriodEnd={reinvestmentPeriodEnd}
                    nonCallPeriodEnd={nonCallPeriodEnd}
                />
            }
        >
            {
                periodEndYears == null
                    ? constants.emptyPlaceholder
                    : <span>
                        {formatUtils.formatBoolean(periodEndYears < 0)} {periodEndYears !== 0 && <span className={cn({ "text-red": periodEndYears < 0 })}>({formatUtils.formatDecimal(periodEndYears)} yrs)</span>}
                    </span>
            }
        </OnHoverTooltip>
    );
}

interface PeriodEndTooltipProps {
    mode: TMode
    title: string,
    issuanceMonitor?: boolean
}
export function PeriodEndTooltip({ mode, title, issuanceMonitor = false }: PeriodEndTooltipProps) {
    const field = mode === 'reinvestment' ? 'RIE' : 'NCE';

    const overlay =
        <ul className="list-bullet">
            <li>'Yes' - if today's date is greater than the date specified in the '{field}' field.</li>
            <li>‘No' - if today's date is less or equal than the date specified in the '{field}' field.</li>
            <li>A '-' will be displayed if there is no data for the {field} field.</li>
            {
                !issuanceMonitor &&
                <>
                    <li>The value in parentheses shows years until the {field.slice(0, -1)} period ends.</li>
                    <li>Negative values indicate how long ago the {field.slice(0, -1)} period ended.</li>
                </>
            }
        </ul>

    return (
        <OnHoverTooltip overlay={overlay}>
            {title}
            <IconSVG name="info" width={16} height={16} />
        </OnHoverTooltip>
    )
}